export function getZoomPublishableUrl(redirectUri: string): string {
  const ZOOM_CLIENT_ID = import.meta.env.VITE_ZOOM_CLIENT_ID ?? 'hbyj35HCRAGZsLGghU7TXA';

  const ZOOM_PUBLISHABLE_URL = `https://zoom.us/oauth/authorize?response_type=code&client_id=${ZOOM_CLIENT_ID}&redirect_uri=${redirectUri}`;

  return ZOOM_PUBLISHABLE_URL;
}
